<script>
import { useEsignStore } from '../../stores/esign'
import { useFormValidation } from '../../composables/useFormValidation'
import EcInput from '../ui/EcInput.vue'
import EcSelect from '../ui/EcSelect.vue'
import EcComboSelect from '../ui/EcComboSelect.vue'
import EcCheckbox from '../ui/EcCheckbox.vue'
import EcButton from '../ui/EcButton.vue'
import EcAlert from '../ui/EcAlert.vue'
import EcErrorBanner from '../ui/EcErrorBanner.vue'
import EcSpinner from '../ui/EcSpinner.vue'
import EcBadge from '../ui/EcBadge.vue'
import { listTemplates } from '../../api/esignApi'

var languageOptions = [
  { value: 'en', label: 'Anglais (États-Unis)' },
  { value: 'da', label: 'Danois' },
  { value: 'de', label: 'Allemand' },
  { value: 'en-GB', label: 'Anglais (Royaume-Uni)' },
  { value: 'es', label: 'Espagnol (Amérique latine)' },
  { value: 'es-ES', label: 'Espagnol (Espagne)' },
  { value: 'fr', label: 'Français' },
  { value: 'it', label: 'Italien' },
  { value: 'nl', label: 'Néerlandais' },
  { value: 'no', label: 'Norvégien' },
  { value: 'pl', label: 'Polonais' },
  { value: 'pt', label: 'Portugais' },
  { value: 'ro', label: 'Roumain' },
  { value: 'bg', label: 'Bulgare' },
  { value: 'ru', label: 'Russe' },
  { value: 'zh-CN', label: 'Chinois simplifié' },
  { value: 'zh-TW', label: 'Chinois traditionnel' },
  { value: 'ja', label: 'Japonais' },
  { value: 'ko', label: 'Coréen' },
  { value: 'el', label: 'Grec' },
  { value: 'ar', label: 'Arabe' },
]

var timezoneOptions = [
  { value: 'Etc/GMT+12', label: '(GMT-12:00) GMT-12' },
  { value: 'Pacific/Samoa', label: '(GMT-11:00) Pacifique/Samoa' },
  { value: 'HST', label: '(GMT-10:00) Hawaï' },
  { value: 'Pacific/Honolulu', label: '(GMT-10:00) Pacifique/Honolulu' },
  { value: 'US/Alaska', label: '(GMT-9:00) États-Unis/Alaska' },
  { value: 'America/Los_Angeles', label: '(GMT-8:00) Amérique/Los Angeles' },
  { value: 'America/Tijuana', label: '(GMT-8:00) Amérique/Tijuana' },
  { value: 'Canada/Pacific', label: '(GMT-8:00) Canada/Pacifique' },
  { value: 'PST', label: '(GMT-8:00) Pacifique' },
  { value: 'America/Vancouver', label: '(GMT-8:00) Amérique/Vancouver' },
  { value: 'America/Denver', label: '(GMT-7:00) Amérique/Denver' },
  { value: 'Canada/Mountain', label: '(GMT-7:00) Canada/Montagnes' },
  { value: 'America/Phoenix', label: '(GMT-7:00) Amérique/Phoenix' },
  { value: 'CST', label: '(GMT-6:00) Centre' },
  { value: 'Canada/Central', label: '(GMT-6:00) Canada/Centre' },
  { value: 'US/Central', label: '(GMT-6:00) États-Unis/Centre' },
  { value: 'America/Regina', label: '(GMT-6:00) Amérique/Regina' },
  { value: 'America/Chicago', label: '(GMT-6:00) Amérique/Chicago' },
  { value: 'America/Bogota', label: '(GMT-5:00) Amérique/Bogota' },
  { value: 'America/Toronto', label: '(GMT-5:00) Amérique/Toronto' },
  { value: 'EST', label: '(GMT-5:00) Est' },
  { value: 'US/Eastern', label: '(GMT-5:00) États-Unis/Est' },
  { value: 'America/Detroit', label: '(GMT-5:00) Amérique/Détroit' },
  { value: 'America/Montreal', label: '(GMT-5:00) Amérique/Montréal' },
  { value: 'America/Panama', label: '(GMT-5:00) Amérique/Panama' },
  { value: 'America/Caracas', label: '(GMT-4:30) Amérique/Caracas' },
  { value: 'America/Puerto_Rico', label: '(GMT-4:00) Amérique/Porto Rico' },
  { value: 'Canada/Atlantic', label: '(GMT-4:00) Canada/Atlantique' },
  { value: 'America/Santiago', label: '(GMT-4:00) Amérique/Santiago' },
  { value: 'America/St_Johns', label: '(GMT-3:30) Amérique/Saint-Jean' },
  { value: 'Canada/Newfoundland', label: '(GMT-3:30) Canada/Terre-Neuve' },
  { value: 'America/Argentina/Buenos_Aires', label: '(GMT-3:00) Argentine/Buenos Aires' },
  { value: 'Brazil/East', label: '(GMT-3:00) Brésil/Est' },
  { value: 'Atlantic/Azores', label: '(GMT-1:00) Atlantique/Açores' },
  { value: 'Atlantic/Cape_Verde', label: '(GMT-1:00) Atlantique/Cap-Vert' },
  { value: 'Africa/Casablanca', label: '(GMT 0:00) Afrique/Casablanca' },
  { value: 'GMT', label: '(GMT 0:00) Greenwich' },
  { value: 'Europe/London', label: '(GMT 0:00) Europe/Londres' },
  { value: 'Africa/Lagos', label: '(GMT+1:00) Afrique/Lagos' },
  { value: 'CET', label: '(GMT+1:00) Europe centrale' },
  { value: 'Europe/Paris', label: '(GMT+1:00) Europe/Paris' },
  { value: 'Europe/Zurich', label: '(GMT+1:00) Europe/Zurich' },
  { value: 'Europe/Amsterdam', label: '(GMT+1:00) Europe/Amsterdam' },
  { value: 'Europe/Madrid', label: '(GMT+1:00) Europe/Madrid' },
  { value: 'Europe/Rome', label: '(GMT+1:00) Europe/Rome' },
  { value: 'Europe/Stockholm', label: '(GMT+1:00) Europe/Stockholm' },
  { value: 'Europe/Warsaw', label: '(GMT+1:00) Europe/Varsovie' },
  { value: 'Africa/Cairo', label: '(GMT+2:00) Afrique/Le Caire' },
  { value: 'Asia/Istanbul', label: '(GMT+2:00) Asie/Istanbul' },
  { value: 'Europe/Helsinki', label: '(GMT+2:00) Europe/Helsinki' },
  { value: 'Africa/Nairobi', label: '(GMT+3:00) Afrique/Nairobi' },
  { value: 'Asia/Tehran', label: '(GMT+3:30) Asie/Téhéran' },
  { value: 'Asia/Dubai', label: '(GMT+4:00) Asie/Dubaï' },
  { value: 'Europe/Moscow', label: '(GMT+4:00) Europe/Moscou' },
  { value: 'Asia/Kabul', label: '(GMT+4:30) Asie/Kaboul' },
  { value: 'Asia/Karachi', label: '(GMT+5:00) Asie/Karachi' },
  { value: 'Asia/Kolkata', label: '(GMT+5:30) Asie/Kolkata' },
  { value: 'Asia/Dhaka', label: '(GMT+6:00) Asie/Dhaka' },
  { value: 'Asia/Bangkok', label: '(GMT+7:00) Asie/Bangkok' },
  { value: 'Asia/Jakarta', label: '(GMT+7:00) Asie/Jakarta' },
  { value: 'Asia/Hong_Kong', label: '(GMT+8:00) Asie/Hong Kong' },
  { value: 'Australia/Perth', label: '(GMT+8:00) Australie/Perth' },
  { value: 'Asia/Seoul', label: '(GMT+9:00) Asie/Séoul' },
  { value: 'Asia/Tokyo', label: '(GMT+9:00) Asie/Tokyo' },
  { value: 'Australia/Adelaide', label: '(GMT+9:30) Australie/Adélaïde' },
  { value: 'Australia/Darwin', label: '(GMT+9:30) Australie/Darwin' },
  { value: 'Australia/Brisbane', label: '(GMT+10:00) Australie/Brisbane' },
  { value: 'Australia/Sydney', label: '(GMT+10:00) Australie/Sydney' },
  { value: 'Asia/Vladivostok', label: '(GMT+11:00) Asie/Vladivostok' },
  { value: 'Pacific/Auckland', label: '(GMT+12:00) Pacifique/Auckland' },
  { value: 'Pacific/Tongatapu', label: '(GMT+13:00) Pacifique/Tongatapu' },
]

export default {
  name: 'TemplateForm',
  components: {
    EcInput,
    EcSelect,
    EcComboSelect,
    EcCheckbox,
    EcButton,
    EcAlert,
    EcErrorBanner,
    EcSpinner,
    EcBadge,
  },
  props: {
    holderType: {
      type: String,
      required: true,
    },
    holderId: {
      type: [String, Number],
      required: true,
    },
    template: {
      type: Object,
      default: null,
    },
  },
  data() {
    var store = useEsignStore()
    var validation = useFormValidation()

    return {
      store: store,
      validation: validation,
      submitting: false,
      cloneFromModel: false,
      selectedModelId: null,
      allTemplatesForClone: [],
      defaultRoles: [
        { code: 'CUSTOMER', label: 'Client' },
        { code: 'OTHER', label: 'Autre' },
      ],
      languageOptions: languageOptions,
      timezoneOptions: timezoneOptions,
      form: {
        name: '',
        excerpt: '',
        email_message: '',
        roles: [],
        meta: {
          language: 'fr',
          timezone: 'GMT',
        },
        model_id: null,
      },
      newRole: '',
    }
  },
  computed: {
    t() {
      return this.$ecTranslate
    },
    isEditMode() {
      return !!this.template
    },
    templateOptions() {
      return this.allTemplatesForClone.map(function (t) {
        return { value: t.id, label: t.name }
      })
    },
  },
  watch: {
    template: {
      immediate: true,
      handler(tpl) {
        if (tpl) {
          this.form = {
            name: tpl.name || '',
            excerpt: tpl.excerpt || tpl.description || '',
            email_message: tpl.email_message || '',
            roles: Array.isArray(tpl.roles)
              ? tpl.roles.map(function (r) { return typeof r === 'string' ? r : r.name })
              : [],
            meta: {
              language: (tpl.meta && tpl.meta.language) || 'fr',
              timezone: (tpl.meta && tpl.meta.timezone) || 'GMT',
            },
            model_id: null,
          }
        } else {
          this.resetForm()
        }
      },
    },
  },
  async mounted() {
    // Load ALL templates independently for clone selector (not tied to the paginated list)
    try {
      var result = await listTemplates(this.holderType, this.holderId, {
        sort: 'name',
        page: { number: 1, size: 500 },
      })
      this.allTemplatesForClone = Array.isArray(result)
        ? result
        : (result && Array.isArray(result.data) ? result.data : [])
    } catch (e) {
      // fallback to store templates if API fails
      this.allTemplatesForClone = this.store.templates
    }
    // Load default data (roles from API)
    try {
      var data = await this.store.fetchDefaultData({})
      if (data && data.roles && data.roles.length) {
        this.defaultRoles = data.roles
      }
    } catch (e) {
      // Keep default roles
    }
  },
  methods: {
    resetForm() {
      this.form = {
        name: '',
        excerpt: '',
        email_message: '',
        roles: [],
        meta: { language: 'fr', timezone: 'GMT' },
        model_id: null,
      }
      this.cloneFromModel = false
      this.selectedModelId = null
      this.newRole = ''
    },
    addRole() {
      var role = this.newRole.trim()
      if (role && !this.form.roles.includes(role)) {
        this.form.roles.push(role)
        this.newRole = ''
      }
    },
    addDefaultRole(code) {
      if (!this.form.roles.includes(code)) {
        this.form.roles.push(code)
      }
    },
    removeRole(index) {
      this.form.roles.splice(index, 1)
    },
    onModelSelected() {
      if (!this.selectedModelId) return
      var tpl = this.store.templates.find(function (t) { return t.id == this })
      // We can't use `this` in find callback easily, use a different approach
      var self = this
      tpl = this.store.templates.find(function (t) { return t.id == self.selectedModelId })
      if (tpl) {
        this.form.name = tpl.name || ''
        this.form.excerpt = tpl.excerpt || tpl.description || ''
        this.form.email_message = tpl.email_message || ''
        this.form.roles = Array.isArray(tpl.roles)
          ? tpl.roles.map(function (r) { return typeof r === 'string' ? r : r.name })
          : []
        this.form.meta = {
          language: (tpl.meta && tpl.meta.language) || 'fr',
          timezone: (tpl.meta && tpl.meta.timezone) || 'GMT',
        }
        this.form.model_id = tpl.id
      }
    },
    onCloneToggle() {
      if (!this.cloneFromModel) {
        this.selectedModelId = null
        this.form.model_id = null
      }
    },
    async onSubmit() {
      var t = this.$ecTranslate
      this.validation.resetApiValidation()
      this.submitting = true

      if (!this.form.name.trim()) {
        this.validation.handleBackendFormError({ errors: { name: [t('ELIXIO_CONNECT.NAME_REQUIRED')] } })
        this.submitting = false
        this.scrollFormToTop()
        return
      }

      if (this.form.roles.length === 0) {
        this.validation.handleBackendFormError({ errors: { roles: [t('ELIXIO_CONNECT.ROLES_REQUIRED')] } })
        this.submitting = false
        this.scrollFormToTop()
        return
      }

      try {
        var payload = Object.assign({}, this.form)
        var result = null

        if (this.isEditMode && this.template) {
          result = await this.store.updateTemplate(this.holderType, this.holderId, this.template.id, payload)
          this.$ecNotify(t('ELIXIO_CONNECT.MODELS_UPDATED'), 'success')
        } else {
          result = await this.store.createTemplate(this.holderType, this.holderId, payload)
          this.$ecNotify(t('ELIXIO_CONNECT.MODELS_ADDED'), 'success')
        }
        this.$emit('saved', result)
      } catch (err) {
        if (err.response && err.response.data && err.response.data.errors) {
          this.validation.handleBackendFormError(err.response.data)
        } else {
          this.validation.handleBackendFormError({
            message: (err.response && err.response.data && err.response.data.message) || t('ELIXIO_CONNECT.SOMETHING_WENT_WRONG'),
          })
        }
        var errorMsg = (this.validation.apiGlobalErrors.length && this.validation.apiGlobalErrors[0]) || t('ELIXIO_CONNECT.SOMETHING_WENT_WRONG')
        this.$ecNotify(errorMsg, 'error')
        this.scrollFormToTop()
      } finally {
        this.submitting = false
      }
    },
    scrollFormToTop() {
      var self = this
      this.$nextTick(function () {
        if (self.$refs.formEl) {
          self.$refs.formEl.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    },
  },
}
</script>

<template>
  <form ref="formEl" @submit.prevent="onSubmit">
    <!-- Global errors -->
    <EcErrorBanner v-if="validation.apiGlobalErrors.length" :errors="validation.apiGlobalErrors" class="ec-mb-3" />

    <!-- Clone from model (create mode only) -->
    <div v-if="!isEditMode" class="ec-mb-3">
      <EcCheckbox
        :value="cloneFromModel"
        :label="t('ELIXIO_CONNECT.CLONE_MODEL')"
        @input="cloneFromModel = $event; onCloneToggle()"
      />

      <div v-if="cloneFromModel" class="ec-mt-2">
        <EcComboSelect
          :value="selectedModelId"
          :label="t('ELIXIO_CONNECT.SELECT_MODEL')"
          :options="templateOptions"
          :placeholder="t('ELIXIO_CONNECT.SELECT')"
          @input="selectedModelId = $event; onModelSelected()"
        />
      </div>
    </div>

    <hr v-if="!isEditMode" style="border-color: var(--ec-border-color, #e2e8f0); margin: 1rem 0" />

    <!-- Name -->
    <EcInput
      :value="form.name"
      :label="t('ELIXIO_CONNECT.NAME') + ' (*)'"
      :placeholder="t('ELIXIO_CONNECT.NAME')"
      required
      :error="validation.getFieldError('name')"
      @input="form.name = $event"
    />

    <!-- Language & Timezone -->
    <div class="ec-form-row ec-mb-3">
      <div class="ec-form-row__col">
        <EcSelect
          :value="form.meta.language"
          :label="t('ELIXIO_CONNECT.LANGUAGE')"
          :options="languageOptions"
          @input="form.meta.language = $event"
        />
      </div>
      <div class="ec-form-row__col">
        <EcSelect
          :value="form.meta.timezone"
          :label="t('ELIXIO_CONNECT.TIMEZONE')"
          :options="timezoneOptions"
          @input="form.meta.timezone = $event"
        />
      </div>
    </div>

    <!-- Roles -->
    <div class="ec-form-group ec-mb-3">
      <label class="ec-form-label">{{ t('ELIXIO_CONNECT.ROLES') }} (*)</label>
      <div v-if="validation.getFieldError('roles')" class="ec-form-error ec-mb-1">{{ validation.getFieldError('roles') }}</div>

      <!-- Role chips -->
      <div v-if="form.roles.length" class="ec-flex ec-gap-1 ec-mb-2" style="flex-wrap: wrap">
        <span
          v-for="(role, idx) in form.roles"
          :key="idx"
          class="ec-role-chip"
        >
          {{ role }}
          <button
            type="button"
            class="ec-role-chip__remove"
            @click="removeRole(idx)"
          >
            <i class="bi bi-x" />
          </button>
        </span>
      </div>

      <!-- Default role buttons -->
      <div class="ec-flex ec-gap-1 ec-mb-2" style="flex-wrap: wrap">
        <EcButton
          v-for="dr in defaultRoles"
          :key="dr.code"
          type="button"
          variant="outline-secondary"
          size="sm"
          icon="plus-lg"
          :disabled="form.roles.includes(dr.code)"
          @click="addDefaultRole(dr.code)"
        >
          {{ dr.label }}
        </EcButton>
      </div>

      <!-- Custom role input -->
      <div class="ec-role-input">
        <input
          v-model="newRole"
          type="text"
          class="ec-input__field"
          :placeholder="t('ELIXIO_CONNECT.ADD_ROLES')"
          @keydown.enter.prevent="addRole"
        />
        <EcButton
          type="button"
          variant="outline-primary"
          size="sm"
          icon="plus-lg"
          :disabled="!newRole.trim()"
          @click="addRole"
        />
      </div>
    </div>

    <!-- Excerpt -->
    <div class="ec-form-group ec-mb-3">
      <label class="ec-form-label">{{ t('ELIXIO_CONNECT.EXCERPT') }}</label>
      <textarea
        v-model="form.excerpt"
        class="ec-textarea"
        rows="3"
        :placeholder="t('ELIXIO_CONNECT.EXCERPT')"
      />
    </div>

    <!-- Email Message -->
    <div class="ec-form-group ec-mb-3">
      <label class="ec-form-label">{{ t('ELIXIO_CONNECT.EMAIL_MESSAGE') }}</label>
      <textarea
        v-model="form.email_message"
        class="ec-textarea"
        rows="3"
        :placeholder="t('ELIXIO_CONNECT.EMAIL_MESSAGE')"
      />
    </div>

    <!-- Actions -->
    <div class="ec-flex ec-justify-end ec-gap-2 ec-mt-4">
      <EcButton type="button" variant="secondary" @click="$emit('cancel')">
        {{ t('ELIXIO_CONNECT.CANCEL') }}
      </EcButton>
      <EcButton type="submit" variant="primary" :disabled="submitting">
        <EcSpinner v-if="submitting" size="sm" style="margin-right: 0.25rem" />
        {{ isEditMode ? t('ELIXIO_CONNECT.EDIT_MODEL') : t('ELIXIO_CONNECT.ADD_MODEL') }}
      </EcButton>
    </div>
  </form>
</template>

<style scoped>
.ec-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

.ec-role-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.2em 0.5em 0.2em 0.6em;
  background: var(--ec-primary, #3b82f6);
  color: #fff;
  border-radius: 4px;
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.4;
}

.ec-role-chip__remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  border-radius: 2px;
  cursor: pointer;
  font-size: 0.875rem;
  line-height: 1;
}

.ec-role-chip__remove:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
}

.ec-role-input {
  display: flex;
  gap: 0.25rem;
}

.ec-role-input .ec-input__field {
  flex: 1;
}
</style>
